import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VendorsResponseModel } from '../models/VendorsResponseModel';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { UtilsService } from './utils/utils.service';
import { ZendeskChatToken } from '../models/ZendeskChatToken';
import { ManageUsersAccountService } from './manage-users-account.service';

@Injectable({
  providedIn: 'root'
})

export class VendorsService {

  private baseUrl = this._utilService.getVendorsUrl();

  constructor(
    private http: HttpClient,
    private _authenticationService: ManageUsersAccountService,
    private _cookie: CookieService,
    private _utilService: UtilsService
  ) { }

  authenticateZendeskChatSession(firstName: string, lastName: string, email: string) {
    const params = {
      userId: this._authenticationService.currentUserValue.userid,
      clientId: this._authenticationService.currentUserValue.activeusertype.clientid,
      name: firstName + " " + lastName,
      email: email,
      context: 'client_platform'
    }
    return this.http.post<VendorsResponseModel<ZendeskChatToken>>(`${this.baseUrl}/zendesk/api/v1/chat/authenticate`, params).pipe(
        map(response => {
            if (response.status === 200) {
                // Set the cookie with the token or any other data from the response
                if (response.message) {
                    this._cookie.set('ZendeskAuthToken', response.message.token, moment.unix(response.message.expiry).toDate(), '/');
                }
                return { data: response.message, message: null };
            } else {
                console.error('Error authenticating Zendesk chat session');
                return { data: [], message: response.message };
            }
          }),
    );
  }
}